import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";
export function ThemeToggle() {
  const {
    isDarkMode,
    toggleDarkMode
  } = useTheme();
  return <button onClick={toggleDarkMode} className="p-2 rounded-lg text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100 transition-colors" aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"} data-id="element-296">
      {isDarkMode ? <Sun className="w-5 h-5" data-id="element-297" /> : <Moon className="w-5 h-5" data-id="element-298" />}
    </button>;
}